ClubCourtsPricesController.$inject = [
    '$scope',
    'CONST',
    '$uibModalInstance',
    'Time',
    '_',
    'court',
    'alerts',
    'User',
];

/* @ngInject */
function ClubCourtsPricesController(
    $scope,
    CONST,
    $uibModalInstance,
    Time,
    _,
    court,
    alerts,
    User,
) {
    var vm = this;
    vm.title = 'ClubCourtsPricesController';
    vm.courtName = court.name;

    vm.loading = true;

    /**
     * @class Durations
     */

    var prices = court.price_modifiers;
    vm.prices = prices;
    vm.days = init_days();

    vm.price_tab = vm.days[0];
    vm.select_tab = function (tab) {
        vm.price_tab = tab;
    };

    vm.durations_list = [];
    vm.durations = {
        10: false,
        30: false,
        45: false,
        60: true,
        90: false,
        120: false,
    };

    vm.durations_select = [];

    $scope.$watch(
        'vm.durations',
        function () {
            vm.durations_list = _.chain(vm.durations)
                .pickBy(_.identity)
                .keys()
                .value();

            vm.durations_select = vm.durations_list[0];
        },
        true,
    );

    /**
     * @class Hours
     */

    vm.hours = {
        list: [],
        add: function (hour) {
            var time = new Time.Hour().fromDate(hour);
            var insert = {
                hour: time.toFloat(),
                str: time.toStringFormalized(),
            };
            vm.hours.list.splice(
                _.sortedLastIndexBy(
                    vm.hours.list,
                    {
                        hour: insert.hour,
                    },
                    'hour',
                ),
                0,
                insert,
            );
        },
        remove: function (pos) {
            alerts.confirm('Borrando duración').then(function () {
                _.pullAt(vm.hours.list, pos);
            });
        },
        model: new Time.Hour(18, 0).toDate(),
    };

    vm.hour_change = {
        target: null,
        open: function (float) {
            var time = new Time.Hour().fromFloat(parseFloat(float));
            vm.hour_change.target = float;
            vm.hour_change.model = time.toDate();
        },
        model: null,
        change: function () {
            var model = new Time.Hour().fromDate(vm.hour_change.model);

            // CLONE STRUCTURE
            swapHour(vm.hour_change.target, model.toFloat());

            // SWAP
            _.remove(vm.hours.list, function (h) {
                return h.hour == vm.hour_change.target;
            });
            vm.hours.add(vm.hour_change.model);

            vm.hour_change.close();
        },
        close: function () {
            vm.hour_change.target = null;
            vm.hour_change.model = null;
        },
    };

    vm.OnChangeDurationInput = function () {
        const duration_match = vm.durations_list.filter(
            (el) => el == vm.durations_select,
        );
        return duration_match;
    };

    /**
     * Prices
     */

    /**
     * Structure that creates the price structure if it does not exist
     * @method getPrice
     * @param  {String} day
     * @param  {String} hour
     * @param  {Number} duration
     * @return {Number}
     */
    vm.getPrice = function (day, hour, duration) {
        var cursor = prices;
        if (!cursor.hasOwnProperty(day)) {
            createDay(prices, day, hour, duration);
        }
        cursor = prices[day];

        if (!cursor.hasOwnProperty(hour)) {
            prices[day] = createHour(prices[day], hour, duration);
        }
        cursor = prices[day][hour];

        if (!cursor.hasOwnProperty(duration)) {
            prices[day][hour] = createDuration(prices[day][hour], duration);
        }
        
        return prices[day][hour][duration];
    };

    /**
     *
     * @method createDuration
     * @param  {Object} current
     * @param  {String} duration
     * @param  {Number} price
     * @return {Object}
     * @private
     */
    function createDuration(current, duration, price) {
        var dur = current || {};
        dur[duration] = price || null;
        return dur;
    }

    /**
     *
     * @method createHour
     * @param  {Object} current
     * @param  {String} hour
     * @param  {Number} duration
     * @param  {Number} price
     * @return {Object}
     * @private
     */
    function createHour(current, hour, duration, price) {
        var h = current || {};
        h[hour] = createDuration(h[hour], duration, price);
        return h;
    }

    /**
     *
     * @method createDay
     * @param  {Object} obj
     * @param  {String} day
     * @param  {String} hour
     * @param  {Number} duration
     * @param  {Number} price
     * @return {Object}
     * @private
     */
    function createDay(obj, day, hour, duration, price) {
        obj[day] = createHour(obj[day], hour, duration, price);
        return obj;
    }

    /**
     * Does a hard validation (matrix generating prices)
     * @method validate
     * @return {Boolean}
     */
    vm.validate = function () {
        var isValid = true;
        _.each(vm.days, function (day) {
            if (!day.enabled) return;

            if (!validateDay(day)) {
                isValid = false;
            }
        });

        return isValid;
    };

    vm.validateDay = _.debounce(validateDay, 400);

    /**
     * Actions
     */

    vm.save = function () {
        if (vm.validate()) {
            alerts.code(null, null, User).then(save);
            return;
        }

        alerts.error(
            'Error',
            'Hay campos de precios inválidos. Por favor verifica que no estén vacíos o que tengan un valor mayor a 0.',
        );
    };
    vm.close = function () {
        $uibModalInstance.dismiss();
    };

    activate();

    ////////////////

    function activate() {
        // Parse init DURATIONS
        (function (price_durations) {
            var durations = _.keys(price_durations);
            _.each(vm.durations, function (enabled, key) {
                vm.durations[key] = _.includes(durations, key);
            });
        })(prices['*']['*']);

        // Parse init HOURS
        var hrs = _.keys(prices['*']);
        vm.hours.list = _.chain(hrs)
            .filter(function (hour) {
                return hour !== '*';
            })
            .sort()
            .map(function (hour) {
                return {
                    hour: hour,
                    str: new Time.Hour().fromFloat(hour).toStringFormalized(),
                };
            })
            .value();

        vm.hours.list.push({
            hour: '*',
            str: 'Después',
        });

        // Parse init DAYS
        var days = _.keys(prices);
        _.each(vm.days, function (day) {
            day.enabled = _.includes(days, day.id);
        });

        vm.loading = false;
    }

    function swapHour(old_hour, new_hour) {
        _.each(vm.prices, function (day) {
            day[new_hour] = _.cloneDeep(day[old_hour]);
        });
    }

    /**
     * Validates a give nday
     * @method validateDay
     * @param  {Day} day
     * @return {Boolean}
     */
    function validateDay(day) {
        var hasInvalid = _.find(_.map(vm.hours.list, 'hour'), function (hour) {
            return _.find(vm.durations_list, function (duration) {
                return !/^[1-9]\d*$/.test(vm.getPrice(day.id, hour, duration));
            });
        });

        if (hasInvalid) {
            day.$invalid = true;
            return false;
        } else {
            day.$invalid = false;
            return true;
        }
    }

    function format_price() {
        var _hours = _.map(vm.hours.list, 'hour');
        var price = {};

        _.each(vm.days, function (day) {
            if (!day.enabled) return;

            price[day.id] = {};
            _.each(_hours, function (hour) {
                price[day.id][hour] = _.pick(
                    vm.prices[day.id][hour],
                    vm.durations_list,
                );
            });
        });
        return price;
    }

    function save(code) {
        var data = {
            price_modifiers: format_price(),
            code: code,
        };

        vm.loading = true;
        return court.api
            .customPUT(data, '')
            .then(function (res) {
                court.price_modifiers = data.price_modifiers;
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }

    /**
     * Creates the days options
     * @method init_days
     * @param  {Object} prices
     * @return {Array of Days}
     */
    function init_days(prices) {
        return [
            {
                id: '*',
                name: 'Genérico',
                enabled: true,
                $invalid: false,
            },
            {
                id: '0',
                name: 'Domingo',
                enabled: false,
                $invalid: false,
            },
            {
                id: '1',
                name: 'Lunes',
                enabled: false,
                $invalid: false,
            },
            {
                id: '2',
                name: 'Martes',
                enabled: false,
                $invalid: false,
            },
            {
                id: '3',
                name: 'Miércoles',
                enabled: false,
                $invalid: false,
            },
            {
                id: '4',
                name: 'Jueves',
                enabled: false,
                $invalid: false,
            },
            {
                id: '5',
                name: 'Viernes',
                enabled: false,
                $invalid: false,
            },
            {
                id: '6',
                name: 'Sábado',
                enabled: false,
                $invalid: false,
            },
            {
                id: '7',
                name: 'Feriados',
                enabled: false,
                $invalid: false,
            },
        ];
    }
}

export default ClubCourtsPricesController;
